import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class FmsService {
    private _fmsUrl = new BehaviorSubject<string>(environment.fmsUrl);

    get fmsUrl$(): Observable<string> {
        return this._fmsUrl.asObservable();
    }

    set fmsUrl$(url: string) {
        this._fmsUrl.next(url);
    }

    setFmsUrl(baseUrl: string, route?: string): void {
        this._fmsUrl.next(baseUrl);
        const path = route?.replace(/^\/(?:external\/)?fms\/?/, '') || null;
        this._fmsPath.next(
            path ? (path.startsWith('/') ? path : `/${path}`) : null
        );
    }

    private _fmsPath = new BehaviorSubject<string | null>(null);

    get fmsPath$(): Observable<string | null> {
        return this._fmsPath.asObservable();
    }

    constructor() {}
}
